// src/pages/seeker/SeekerAvailability.jsx
// Route: /seeker/availability

import React, { useEffect, useState } from 'react';
import { seekerAPI } from '../../services/api';
import toast from 'react-hot-toast';

const C = {
  navy: '#0e4e95', white: '#ffffff',
  offwhite: '#f4f7fb', text: '#1a1a1a', muted: '#666',
  border: '#d0daea',
};

const FL = ({ label, children, hint }) => (
  <div style={{ marginBottom: '14px' }}>
    <label className="form-label" style={{ textTransform: 'none', letterSpacing: 0, fontWeight: 600, color: 'var(--primary)', fontSize: '12px' }}>
      {label}{hint && <span style={{ fontWeight: 400, color: 'var(--text-muted)', marginLeft: '6px' }}>{hint}</span>}
    </label>
    {children}
  </div>
);

const FS = ({ value, onChange, options }) => (
  <select value={value || ''} onChange={e => onChange(e.target.value)} className="form-input" style={{ background: 'white' }}>
    <option value="">— select —</option>
    {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
  </select>
);

export const SeekerAvailability = () => {
  const [loading,           setLoading]           = useState(true);
  const [lookingForWork,    setLookingForWork]    = useState('');
  const [availabilityStatus, setAvailabilityStatus] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await seekerAPI.getProfile();
        const p   = res.data.data;
        setAvailabilityStatus(p.availabilityStatus || '');
        setLookingForWork((p.workPreferences || {}).lookingForWork || '');
      } catch { toast.error('Failed to load availability'); }
      finally { setLoading(false); }
    };
    load();
  }, []);

  const saveField = async (field, val) => {
    try {
      await seekerAPI.updateProfile({ [field]: val === '' ? null : val });
      toast.success('Saved', { duration: 1200, id: 'autosave' });
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Save failed');
    }
  };

  const savePrefsField = async (field, val) => {
    try {
      const res  = await seekerAPI.getProfile();
      const prefs = res.data.data.workPreferences || {};
      await seekerAPI.updateProfile({ workPreferences: { ...prefs, [field]: val } });
      toast.success('Saved', { duration: 1200, id: 'autosave' });
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Save failed');
    }
  };

  if (loading) return <div style={{ padding: '40px', color: 'var(--text-muted)' }}>Loading…</div>;

  const card = { background: C.white, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '20px 24px', marginBottom: '40px' };

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>Availability</h1>
        <p>Changes are saved automatically.</p>
      </div>

      <div className="page-content">
        <div style={card}>

          <FL label="Looking for Work">
            <div style={{ display: 'flex', gap: '20px', marginTop: '4px' }}>
              {[{ v: 'AVAILABLE', l: 'Available' }, { v: 'UNAVAILABLE', l: 'Unavailable' }].map(({ v, l }) => (
                <label key={v} style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '13px', color: 'var(--text)', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="lookingForWork"
                    value={v}
                    checked={lookingForWork === v}
                    onChange={() => { setLookingForWork(v); savePrefsField('lookingForWork', v); }}
                    style={{ accentColor: 'var(--primary)', width: '15px', height: '15px', cursor: 'pointer' }}
                  />
                  {l}
                </label>
              ))}
            </div>
          </FL>

          <FL label="Available to Start">
            <FS
              value={availabilityStatus}
              onChange={(val) => { setAvailabilityStatus(val); saveField('availabilityStatus', val); }}
              options={[
                { value: 'IMMEDIATELY',  label: 'Immediately' },
                { value: 'ONE_WEEK',     label: '1 Week' },
                { value: 'TWO_WEEKS',    label: '2 Weeks' },
                { value: 'ONE_MONTH',    label: '1 Month' },
                { value: 'TWO_MONTHS',   label: '2 Months' },
                { value: 'THREE_MONTHS', label: '3 Months' },
                { value: 'NEGOTIABLE',   label: 'Negotiable' },
              ]}
            />
          </FL>

        </div>
      </div>
    </div>
  );
};
